import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ element, isAuthenticated, loading }) => {
  console.log('ProtectedRoutes - isAuthenticated:', isAuthenticated); // Debug log

  if (loading) {
    return <div>Loading...</div>; // Show loading indicator
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />; // Redirect to sign-in if not authenticated
  }

  // Render the element as a React component
  return React.createElement(element);
};

export default ProtectedRoutes;